export const navLinks = [
    {
      id: "about",
      title: "Acerca de mí",
      link: "#about-me"
    },
    {
      id: "work",
      title: "Trabajo",
      link: "#work"
    },
    {
      id: "projects",
      title: "Proyectos",
      link: "#projects"
    },
    {
      id: "others",
      title: "Otros",
      link: "#others"
    },
    {
      id: "contact",
      title: "Contacto",
      link: "#contact"
    },
  ];

  export const HeroTexts = [
    {
        id: "subtitle",
        title: "Hola, mi nombre es:",
    },

    {
        id: "title-name",
        title: "Alejandro Cevallos.",
    },
    {
        id: "button-text",
        title: "¿Hablemos!",
    }
  ]